module.exports = __webpack_public_path__ + "static/weJay2-d9d59e47583807558224304815db0408.png";